import apiFetch from '../apiFetch'

export default function (token, documentType) {
  return apiFetch({ endPoint: 'DocumentType', method: 'POST', body: documentType, token: token })
}
